import {createFileRoute, Outlet, redirect} from '@tanstack/react-router'

import {getStoredUser} from 'src/lib/auth'

export const Route = createFileRoute('/_authed/admin')({
    beforeLoad: () => {
        const user = getStoredUser()
        if (!user?.is_admin) {
            throw redirect({to: '/'})
        }
    },
    component: AdminLayout,
})

function AdminLayout() {
    return <Outlet />
}
